import { useState } from 'react';
import { CASE_TYPE_GROUPS, CASE_TYPES } from '../constants/caseTypes';

/**
 * Case type selector with grouped built-in types and custom value support.
 *
 * Props:
 *   value     — current case_type string
 *   onChange  — callback(newValue)
 *   className — optional CSS class for the wrapper
 *   name      — optional name attribute
 */
export default function CaseTypeSelect({ value, onChange, className = 'input', name }) {
  const isBuiltIn = CASE_TYPES.some(t => t.value === value);
  const [customMode, setCustomMode] = useState(!isBuiltIn && value && value !== 'other');
  const [customValue, setCustomValue] = useState(customMode ? value : '');

  const handleSelectChange = (e) => {
    const v = e.target.value;
    if (v === '__custom__') {
      setCustomMode(true);
      setCustomValue('');
      // Don't fire onChange yet — wait for user to type
    } else {
      setCustomMode(false);
      onChange(v);
    }
  };

  const handleCustomChange = (e) => {
    const raw = e.target.value;
    // Normalize to snake_case for storage
    const normalized = raw.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
    setCustomValue(raw);
    if (normalized) onChange(normalized);
  };

  if (customMode) {
    return (
      <div className="case-type-custom-wrap">
        <input
          className={className}
          type="text"
          value={customValue}
          onChange={handleCustomChange}
          placeholder="Enter custom case type…"
          maxLength={100}
          name={name}
        />
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          onClick={() => { setCustomMode(false); onChange('other'); }}
          title="Back to list"
        >
          ← List
        </button>
      </div>
    );
  }

  return (
    <select
      className={className}
      value={isBuiltIn ? value : 'other'}
      onChange={handleSelectChange}
      name={name}
    >
      {CASE_TYPE_GROUPS.map(group => (
        <optgroup key={group.label} label={group.label}>
          {group.types.map(t => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </optgroup>
      ))}
      <optgroup label="─────────────">
        <option value="__custom__">Custom…</option>
      </optgroup>
    </select>
  );
}
